import {createSelector} from 'reselect';

import {getUserThreadsSliceState} from './get_user_threads_state';

export const selectManuallyReadThreadIds = createSelector(
    getUserThreadsSliceState,
    (state) => state.manuallyReadThreadIds,

);
